import GSS	from "./circuits/gss.js";

class CO2Sensor extends GSS {
  constructor(p) {
    super();

    this.id = "uninitalized";
    this.status = "uninitialized";
    this.name = "co2Sensor";
  }
  async initialize() {
    await this.open("/dev/ttyCO2");
    await this.setOperatingMode(GSS.MODE_POLLING);
    this.id = await this.getDeviceInformation();
    this.status = "ok";
  }
  async update() {
    this.value = await this.getFilteredGasConcentration();
    this.temperature = await this.getTemperature();
    this.relativeHumidity = await this.getRelativeHumidity();
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      value: this.value,
      temperature: this.temperature,
      relativeHumidity: this.relativeHumidity
    });
  }
}

export default CO2Sensor;